<template>
    <div v-loading="loading">
        <el-table :data="compare" key="add" border style="width:97%">
            <el-table-column label="修改项" prop="name"></el-table-column>
            <el-table-column label="修改前" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import CommonService from "~/services/common";
    export default {
        name: "szxy",
        props:{
            edit_content:{
                required:true
            }
        },
        data(){
            return {
                loading:true,
                apps:[],
                compare:[]
            }
        },
        mounted(){
            CommonService.getAllAPP().then(res => {
                this.apps = res.data;
                this.loading = false;
                this.compareApp();
            });
        },
        methods:{
            compareApp(){
                let fields = {
                    name:'开通应用',
                    before:this.getAppName(this.edit_content.before_content.open_app),
                    after:this.getAppName(this.edit_content.content.open_app)
                };
                if(fields.after != fields.before){
                    fields.after = "<span style='color: red'>"+fields.after+"</span>";
                }
                this.compare.push(fields);
            },
            getAppName(obj){
                if(!obj) return '';
                let app_name = [];
                this.apps.map(i=>{
                    if(obj.filter((item)=> { return item.app_id == i.app_id }).length > 0){
                        app_name.push(i.app_name);
                    }
                });
                return app_name.join('<br/>');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/szxy.vue